module.exports = __webpack_public_path__ + "img/bovas_1a.2f9d9645.png";